import { addStyles } from 'ethcss'
import { colors, IStyles, palette } from 'theme'
import { cols, mediaCSS } from 'theme/media'

export const styles: IStyles = {
    wrapper: {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: `${cols.normal}%`,
        zIndex: 1000,
        overflowY: 'auto',
        backgroundColor: palette.white.main,
        [mediaCSS.tab]: {
            top: 44,
            left: 0,
        },
    },
    content: {
        width: '100%',
        maxWidth: 1320,
        padding: '28px 36px 48px',
        [mediaCSS.tabMini]: {
            padding: '20px 18px 36px',
        },
    },
    backButton: {
        appearance: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        minHeight: 30,
        margin: 0,
        padding: '4px 10px',
        border: `1px solid ${colors.greyLight}`,
        borderRadius: 4,
        backgroundColor: colors.white,
        color: colors.blackLight,
        fontSize: 12,
        cursor: 'pointer',
        '&:hover': {
            borderColor: colors.blueAccent,
            color: colors.blueAccent,
        },
        '&:focus-visible': {
            outline: `2px solid ${colors.blueAccent}`,
            outlineOffset: 2,
        },
    },
    backIcon: {
        marginRight: 7,
        fontSize: 20,
        fontWeight: 300,
        lineHeight: 1,
        transform: 'translateY(-1px)',
    },
    title: {
        margin: '18px 0 22px',
        color: colors.blackLight,
        fontSize: 20,
        fontWeight: 500,
        lineHeight: 1.3,
    },
    group: {
        paddingBottom: 18,
        marginBottom: 18,
        borderBottom: `1px solid ${colors.greyLight}`,
        '&:last-child': {
            marginBottom: 0,
            borderBottom: 0,
        },
    },
    field: {
        marginBottom: 14,
        '&:last-child': {
            marginBottom: 0,
        },
    },
    label: {
        marginBottom: 6,
        color: colors.blackLight,
        fontSize: 12,
        fontWeight: 600,
        lineHeight: '16px',
    },
    value: {
        display: 'flex',
        alignItems: 'flex-start',
        minHeight: 36,
        padding: '9px 11px',
        overflowWrap: 'anywhere',
        border: `1px solid ${colors.greyLight}`,
        borderRadius: 4,
        backgroundColor: colors.white,
        color: colors.blackLight,
        fontSize: 13,
        lineHeight: '17px',
        whiteSpace: 'pre-wrap',
    },
    accent: {
        flex: '0 0 2px',
        alignSelf: 'stretch',
        minHeight: 17,
        marginRight: 9,
        borderRadius: 1,
    },
    actionButton: {
        appearance: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        minHeight: 30,
        padding: '5px 10px',
        border: `1px solid ${colors.greyLight}`,
        borderRadius: 4,
        backgroundColor: colors.white,
        color: colors.blackLight,
        fontSize: 12,
        cursor: 'pointer',
        '&:hover': {
            borderColor: colors.blueAccent,
            color: colors.blueAccent,
        },
    },
    actionIcon: {
        marginRight: 7,
    },
}

addStyles(styles)
